import { Auth } from 'aws-amplify';
import { signOutAction } from 'state/reducers/auth-reducer';
import { store } from 'state/store';

export function signOutHandler() {
  store.dispatch(signOutAction());
  return Auth.signOut();
}
